//import { motion } from "framer-motion";

const config = {
  s: 20,
  d: 1,
  e: [0.1, 0.4, 0.4, 1.0]
}

export const userInterface = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: config.d,
      delay: config.d
    }
  }
}

export const containers = {
  hidden: { opacity: 0, y: -config.s },
  first: {
    opacity: 1,
    y: 0,
    transition: {
      duration: config.d / 2,
      delay: config.d / 2,
      type: 'tween',
      ease: "easeOut"
    }

  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: config.d / 2,
      delay: config.d,
      //ease: config.e,
      type: 'tween', //physical spring transition
      //damping: 50, //how quickly the spring slows down
      //stiffness: 1000, // how "stiff" the spring is
      ease: "easeOut"
    }
  },
  exit: {
    y: config.s,
    opacity: 0,
    transition: {
      duration: config.d / 2,
      type: "tween",
      ease: "easeIn"
    }
  }
}

export const items = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      duration: config.d,
      staggerChildren: 0.5,
      type: 'spring', //physical spring transition
      damping: 20, //how quickly the spring slows down
      stiffness: 100, // how "stiff" the spring is
    }
  },
  exit: {
    opacity: 0
  }

}

export const loading = {
  hidden: { opacity: 1, height: 30 },
  show: {
    opacity: 1,
    height: 0
  },
  exit: {
    opacity: 1,
    height: 30,
    transition: {
      ease: config.e
    }
  }
}

export const splitSentence = {
  hidden: {opacity: 1},
  visible: {
    opacity: 1,
    transition: {
      delay:0.5,
      staggerChildren: 0.08
    }
  }
}

export const splitLetter = {
  hidden: { opacity: 1, y: 50},
  visible: {
    opacity: 1,
    y: 0
  }
}